/* 2026-10-13 · Ficha de libro (modelo Manifest): ficha técnica, barra de compra móvil y portada en carrusel */
(() => {
  const mobile = window.matchMedia('(max-width: 47.125rem)');
  document.querySelectorAll('[data-mf-fitxa]').forEach((technical) => {
    if (mobile.matches) technical.open = false;
    const summary = technical.querySelector('summary');
    if (summary) summary.addEventListener('click', (e) => { if (!mobile.matches) e.preventDefault(); });
  });
  // Barra móvil: compra con el mismo botón de la tarjeta para abrir el panel lateral de la cesta
  document.querySelectorAll('[data-verso-bar-form]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      const button = document.getElementById(form.dataset.versoBarForm + '-add-button');
      if (!button) return;
      e.preventDefault();
      button.click();
    });
  });
  const purchase = document.getElementById('verso-formats');
  const bar = document.querySelector('[data-verso-bar]');
  if (purchase && bar && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      const visible = !entry.isIntersecting && entry.boundingClientRect.top < 0 && window.matchMedia('(max-width: 47.125rem)').matches;
      bar.hidden = !visible;
      bar.classList.toggle('is-visible', visible);
    }).observe(purchase);
  }
  if (!customElements.get('verso-cover-carousel')) {
    customElements.define('verso-cover-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const track = this.querySelector('[data-track]');
        const slides = Array.from(this.querySelectorAll('.vl-cover__slide'));
        const dots = Array.from(this.querySelectorAll('[data-dot]'));
        const zoom = this.querySelector('.c-image-overlay__image');
        if (!track || slides.length < 2) return;
        let index = 0;
        const setActive = (i) => {
          index = i;
          dots.forEach((d, k) => d.setAttribute('aria-current', k === i ? 'true' : 'false'));
          const s = slides[i];
          if (zoom && s) {
            zoom.src = s.dataset.zoomSrc;
            zoom.srcset = s.dataset.zoomSrcset;
            zoom.height = Number(s.dataset.zoomHeight);
          }
        };
        const go = (i) => {
          i = (i + slides.length) % slides.length;
          track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
          setActive(i);
        };
        this.querySelector('[data-prev]').addEventListener('click', () => go(index - 1));
        this.querySelector('[data-next]').addEventListener('click', () => go(index + 1));
        dots.forEach((d) => d.addEventListener('click', () => go(Number(d.dataset.dot))));
        track.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
        });
        let t;
        track.addEventListener('scroll', () => {
          clearTimeout(t);
          t = setTimeout(() => {
            const i = Math.round(track.scrollLeft / track.clientWidth);
            if (i !== index && slides[i]) setActive(i);
          }, 80);
        }, { passive: true });
      }
    });
  }
})();